import { render, staticRenderFns } from "./OnLeave.vue?vue&type=template&id=59bbc4ab"
import script from "./OnLeave.vue?vue&type=script&lang=js"
export * from "./OnLeave.vue?vue&type=script&lang=js"
import style0 from "./OnLeave.vue?vue&type=style&index=0&id=59bbc4ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports